export default __webpack_public_path__ + "static/media/server_white.a51ef5b2.svg";